import { AgencyBrand, BrandingMode } from 'enums';
import { Quote, SubmissionDraft } from 'types';

export interface QuoteComparisonInsightsLocationState {
  quotes: Quote[];
  expiringPolicyFileId?: string;
  savedDraft?: SubmissionDraft;
  brandingMode?: BrandingMode;
  agencyBrand?: AgencyBrand;
}

export enum PdfGenerationStatus {
  Idle = 'Idle',
  Loading = 'Loading',
  Error = 'Error',
}
